import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { TheWestSection } from '@news-mono/common'
import { Election, StaticRoutes } from '@news-mono/web-common'
import {
    createFederalElectionRoutes,
    createStateElectionRoutes,
} from './pages/createRoutes'
import { createElectionWidgetTestPage } from './pages/electionWidgetTestPage'

const WA_STATE_2025_DESKTOP: string = require('./assets/WAStateElection2025LogoDesktop.svg')
const WA_STATE_2025_MOBILE: string = require('./assets/WAStateElection2025LogoMobile.svg')
const FEDERAL_2025_DESKTOP: string = require('./assets/FederalElection2025LogoDesktop.svg')
const FEDERAL_2025_MOBILE: string = require('./assets/FederalElection2025LogoMobile.svg')

// Currently hardcoded election list.
// To be allow for an easier conversion to a server-resolved route.
const elections: Election[] = [
    {
        type: 'federal',
        year: 2025,
        logo: {
            mobile: FEDERAL_2025_MOBILE,
            desktop: FEDERAL_2025_DESKTOP,
        },
    },
    {
        type: 'state',
        state: 'wa',
        year: 2025,
        logo: {
            mobile: WA_STATE_2025_MOBILE,
            desktop: WA_STATE_2025_DESKTOP,
        },
    },
]

const getElectionRoutes = (elections: Election[]) => {
    let pages: StaticRoutes<TheWestSection> = {
        ['/politics/election-widget-test-page']: ({
            getAdTargeting,
            store,
        }) => {
            const enableRoute = isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'election-widget-test-page',
            )

            if (!enableRoute) {
                return null
            }

            return createElectionWidgetTestPage({
                // Default to the latest election.
                election: elections[0],
                getAdTargeting,
            })
        },
    }

    for (const election of elections) {
        if (election.type === 'federal') {
            pages = {
                ...pages,
                ...createFederalElectionRoutes(election),
            }
        } else {
            pages = {
                ...pages,
                ...createStateElectionRoutes(election),
            }
        }
    }

    return pages
}

export const electionRoutes = getElectionRoutes(elections)
